module.exports = __webpack_public_path__ + "assets/img/29_31.883520cf.jpg";